module.exports = __webpack_public_path__ + "static/media/star.da70a361.svg";